import * as React from "react";
import { forwardRef } from "react";
const BluetoothIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.513 3.042a.75.75 0 0 1 .817.163l4.8 4.8a.75.75 0 0 1 0 1.061l-3.685 3.684 3.637 3.658a.75.75 0 0 1-.002 1.059l-4.75 4.75a.75.75 0 0 1-1.28-.53v-6.54l-3.17 3.17a.75.75 0 0 1-1.061-1.061l4.23-4.23v-.555L7.017 8.415l-.051-.058a.75.75 0 0 1 1.058-1.052l.058.051 2.968 2.984V3.735a.75.75 0 0 1 .463-.693zm1.037 16.833 2.94-2.94-2.94-2.957v5.898zm0-8.351 2.989-2.989-2.989-2.989v5.979z"
}));
const ForwardRef = forwardRef(BluetoothIcon);
export default ForwardRef;